export default "__VITE_ASSET__C8gVZFV5__"